import TaxonomyAdminScreen from "../taxonomy/taxonomy-admin-screen.tsx";

export default function DirectorsScreen() {
  return <TaxonomyAdminScreen type="directors" title="کارگردان‌ها" />;
}
